import styled from '@emotion/styled';
import { colors, spacing, typography } from '#themes/stena-recycling';

export const PeriodButton = styled.button`
  ${typography.body.large};
  border-radius: ${spacing.tiny};
  border: 1px solid ${colors.primary.blue};
  color: ${colors.primary.blue};
  cursor: pointer;
  padding: ${spacing.tiny} ${spacing.xxsmall};
  background-color: transparent;
  letter-spacing: 0.5px;
  white-space: nowrap;

  &:hover {
    background-color: #e6e6e6;
  }

  &:active {
    background-color: #d6d7d9;
  }
`;
